"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "DatasController", {
    enumerable: true,
    get: function() {
        return DatasController;
    }
});
const _common = require("@nestjs/common");
const _globalguard = require("~/guards/global/global.guard");
const _datasservice = require("~/services/datas.service");
const _extractidsmiddleware = require("~/middlewares/extract-ids/extract-ids.middleware");
const _dataapilimiterguard = require("~/guards/data-api-limiter.guard");
const _tenantcontextdecorator = require("~/decorators/tenant-context.decorator");
const _config = require("~/interface/config");
function _ts_decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function _ts_metadata(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
function _ts_param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
let DatasController = class DatasController {
    async dataList(context, req, viewId) {
        return await this.datasService.dataListByViewId(context, {
            viewId: viewId,
            query: req.query
        });
    }
    async mmList(context, req, viewId, colId, rowId) {
        return await this.datasService.mmList(context, {
            viewId: viewId,
            colId: colId,
            rowId: rowId,
            query: req.query
        });
    }
    async mmExcludedList(context, req, viewId, colId, rowId) {
        return await this.datasService.mmExcludedList(context, {
            viewId: viewId,
            colId: colId,
            rowId: rowId,
            query: req.query
        });
    }
    async hmExcludedList(context, req, viewId, colId, rowId) {
        await this.datasService.hmExcludedList(context, {
            viewId: viewId,
            colId: colId,
            rowId: rowId,
            query: req.query
        });
    }
    async btExcludedList(context, req, viewId, colId, rowId) {
        return await this.datasService.btExcludedList(context, {
            viewId: viewId,
            colId: colId,
            rowId: rowId,
            query: req.query
        });
    }
    async hmList(context, req, viewId, colId, rowId) {
        return await this.datasService.hmList(context, {
            viewId: viewId,
            colId: colId,
            rowId: rowId,
            query: req.query
        });
    }
    async dataRead(context, req, viewId, rowId) {
        return await this.datasService.dataReadByViewId(context, {
            viewId,
            rowId,
            query: req.query
        });
    }
    async dataInsert(context, req, viewId, body) {
        return await this.datasService.dataInsertByViewId(context, {
            viewId: viewId,
            body: body,
            cookie: req
        });
    }
    async dataUpdate(context, req, viewId, rowId, body) {
        return await this.datasService.dataUpdateByViewId(context, {
            viewId: viewId,
            rowId: rowId,
            body: body,
            cookie: req
        });
    }
    async dataDelete(context, req, viewId, rowId) {
        return await this.datasService.dataDeleteByViewId(context, {
            viewId: viewId,
            rowId: rowId,
            cookie: req
        });
    }
    async relationDataDelete(context, req, viewId, rowId, relationType, colId, childId) {
        await this.datasService.relationDataDelete(context, {
            viewId: viewId,
            colId: colId,
            childId: childId,
            rowId: rowId,
            cookie: req
        });
        return {
            msg: 'The relation data has been deleted successfully'
        };
    }
    async relationDataAdd(context, req, viewId, rowId, relationType, colId, childId) {
        await this.datasService.relationDataAdd(context, {
            viewId: viewId,
            colId: colId,
            childId: childId,
            rowId: rowId,
            cookie: req
        });
        return {
            msg: 'The relation data has been created successfully'
        };
    }
    constructor(datasService){
        this.datasService = datasService;
    }
};
_ts_decorate([
    (0, _common.Get)('/data/:viewId/'),
    (0, _extractidsmiddleware.Acl)('dataList'),
    _ts_param(0, (0, _tenantcontextdecorator.TenantContext)()),
    _ts_param(1, (0, _common.Req)()),
    _ts_param(2, (0, _common.Param)('viewId')),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcContext === "undefined" ? Object : _config.NcContext,
        typeof _config.NcRequest === "undefined" ? Object : _config.NcRequest,
        String
    ]),
    _ts_metadata("design:returntype", Promise)
], DatasController.prototype, "dataList", null);
_ts_decorate([
    (0, _common.Get)('/data/:viewId/:rowId/mm/:colId'),
    (0, _extractidsmiddleware.Acl)('mmList'),
    _ts_param(0, (0, _tenantcontextdecorator.TenantContext)()),
    _ts_param(1, (0, _common.Req)()),
    _ts_param(2, (0, _common.Param)('viewId')),
    _ts_param(3, (0, _common.Param)('colId')),
    _ts_param(4, (0, _common.Param)('rowId')),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcContext === "undefined" ? Object : _config.NcContext,
        typeof _config.NcRequest === "undefined" ? Object : _config.NcRequest,
        String,
        String,
        String
    ]),
    _ts_metadata("design:returntype", Promise)
], DatasController.prototype, "mmList", null);
_ts_decorate([
    (0, _common.Get)('/data/:viewId/:rowId/mm/:colId/exclude'),
    (0, _extractidsmiddleware.Acl)('mmExcludedList'),
    _ts_param(0, (0, _tenantcontextdecorator.TenantContext)()),
    _ts_param(1, (0, _common.Req)()),
    _ts_param(2, (0, _common.Param)('viewId')),
    _ts_param(3, (0, _common.Param)('colId')),
    _ts_param(4, (0, _common.Param)('rowId')),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcContext === "undefined" ? Object : _config.NcContext,
        typeof _config.NcRequest === "undefined" ? Object : _config.NcRequest,
        String,
        String,
        String
    ]),
    _ts_metadata("design:returntype", Promise)
], DatasController.prototype, "mmExcludedList", null);
_ts_decorate([
    (0, _common.Get)('/data/:viewId/:rowId/hm/:colId/exclude'),
    (0, _extractidsmiddleware.Acl)('hmExcludedList'),
    _ts_param(0, (0, _tenantcontextdecorator.TenantContext)()),
    _ts_param(1, (0, _common.Req)()),
    _ts_param(2, (0, _common.Param)('viewId')),
    _ts_param(3, (0, _common.Param)('colId')),
    _ts_param(4, (0, _common.Param)('rowId')),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcContext === "undefined" ? Object : _config.NcContext,
        typeof _config.NcRequest === "undefined" ? Object : _config.NcRequest,
        String,
        String,
        String
    ]),
    _ts_metadata("design:returntype", Promise)
], DatasController.prototype, "hmExcludedList", null);
_ts_decorate([
    (0, _common.Get)('/data/:viewId/:rowId/bt/:colId/exclude'),
    (0, _extractidsmiddleware.Acl)('btExcludedList'),
    _ts_param(0, (0, _tenantcontextdecorator.TenantContext)()),
    _ts_param(1, (0, _common.Req)()),
    _ts_param(2, (0, _common.Param)('viewId')),
    _ts_param(3, (0, _common.Param)('colId')),
    _ts_param(4, (0, _common.Param)('rowId')),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcContext === "undefined" ? Object : _config.NcContext,
        typeof _config.NcRequest === "undefined" ? Object : _config.NcRequest,
        String,
        String,
        String
    ]),
    _ts_metadata("design:returntype", Promise)
], DatasController.prototype, "btExcludedList", null);
_ts_decorate([
    (0, _common.Get)('/data/:viewId/:rowId/hm/:colId'),
    (0, _extractidsmiddleware.Acl)('hmList'),
    _ts_param(0, (0, _tenantcontextdecorator.TenantContext)()),
    _ts_param(1, (0, _common.Req)()),
    _ts_param(2, (0, _common.Param)('viewId')),
    _ts_param(3, (0, _common.Param)('colId')),
    _ts_param(4, (0, _common.Param)('rowId')),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcContext === "undefined" ? Object : _config.NcContext,
        typeof _config.NcRequest === "undefined" ? Object : _config.NcRequest,
        String,
        String,
        String
    ]),
    _ts_metadata("design:returntype", Promise)
], DatasController.prototype, "hmList", null);
_ts_decorate([
    (0, _common.Get)('/data/:viewId/:rowId'),
    (0, _extractidsmiddleware.Acl)('dataRead'),
    _ts_param(0, (0, _tenantcontextdecorator.TenantContext)()),
    _ts_param(1, (0, _common.Req)()),
    _ts_param(2, (0, _common.Param)('viewId')),
    _ts_param(3, (0, _common.Param)('rowId')),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcContext === "undefined" ? Object : _config.NcContext,
        typeof _config.NcRequest === "undefined" ? Object : _config.NcRequest,
        String,
        String
    ]),
    _ts_metadata("design:returntype", Promise)
], DatasController.prototype, "dataRead", null);
_ts_decorate([
    (0, _common.Post)('/data/:viewId/'),
    (0, _common.HttpCode)(200),
    (0, _extractidsmiddleware.Acl)('dataInsert'),
    _ts_param(0, (0, _tenantcontextdecorator.TenantContext)()),
    _ts_param(1, (0, _common.Req)()),
    _ts_param(2, (0, _common.Param)('viewId')),
    _ts_param(3, (0, _common.Body)()),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcContext === "undefined" ? Object : _config.NcContext,
        typeof _config.NcRequest === "undefined" ? Object : _config.NcRequest,
        String,
        Object
    ]),
    _ts_metadata("design:returntype", Promise)
], DatasController.prototype, "dataInsert", null);
_ts_decorate([
    (0, _common.Patch)('/data/:viewId/:rowId'),
    (0, _extractidsmiddleware.Acl)('dataUpdate'),
    _ts_param(0, (0, _tenantcontextdecorator.TenantContext)()),
    _ts_param(1, (0, _common.Req)()),
    _ts_param(2, (0, _common.Param)('viewId')),
    _ts_param(3, (0, _common.Param)('rowId')),
    _ts_param(4, (0, _common.Body)()),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcContext === "undefined" ? Object : _config.NcContext,
        typeof _config.NcRequest === "undefined" ? Object : _config.NcRequest,
        String,
        String,
        Object
    ]),
    _ts_metadata("design:returntype", Promise)
], DatasController.prototype, "dataUpdate", null);
_ts_decorate([
    (0, _common.Delete)('/data/:viewId/:rowId'),
    (0, _extractidsmiddleware.Acl)('dataDelete'),
    _ts_param(0, (0, _tenantcontextdecorator.TenantContext)()),
    _ts_param(1, (0, _common.Req)()),
    _ts_param(2, (0, _common.Param)('viewId')),
    _ts_param(3, (0, _common.Param)('rowId')),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcContext === "undefined" ? Object : _config.NcContext,
        typeof _config.NcRequest === "undefined" ? Object : _config.NcRequest,
        String,
        String
    ]),
    _ts_metadata("design:returntype", Promise)
], DatasController.prototype, "dataDelete", null);
_ts_decorate([
    (0, _common.Delete)('/data/:viewId/:rowId/:relationType/:colId/:childId'),
    (0, _extractidsmiddleware.Acl)('relationDataDelete'),
    _ts_param(0, (0, _tenantcontextdecorator.TenantContext)()),
    _ts_param(1, (0, _common.Req)()),
    _ts_param(2, (0, _common.Param)('viewId')),
    _ts_param(3, (0, _common.Param)('rowId')),
    _ts_param(4, (0, _common.Param)('relationType')),
    _ts_param(5, (0, _common.Param)('colId')),
    _ts_param(6, (0, _common.Param)('childId')),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcContext === "undefined" ? Object : _config.NcContext,
        typeof _config.NcRequest === "undefined" ? Object : _config.NcRequest,
        String,
        String,
        String,
        String,
        String
    ]),
    _ts_metadata("design:returntype", Promise)
], DatasController.prototype, "relationDataDelete", null);
_ts_decorate([
    (0, _common.Post)('/data/:viewId/:rowId/:relationType/:colId/:childId'),
    (0, _common.HttpCode)(200),
    (0, _extractidsmiddleware.Acl)('relationDataAdd'),
    _ts_param(0, (0, _tenantcontextdecorator.TenantContext)()),
    _ts_param(1, (0, _common.Req)()),
    _ts_param(2, (0, _common.Param)('viewId')),
    _ts_param(3, (0, _common.Param)('rowId')),
    _ts_param(4, (0, _common.Param)('relationType')),
    _ts_param(5, (0, _common.Param)('colId')),
    _ts_param(6, (0, _common.Param)('childId')),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcContext === "undefined" ? Object : _config.NcContext,
        typeof _config.NcRequest === "undefined" ? Object : _config.NcRequest,
        String,
        String,
        String,
        String,
        String
    ]),
    _ts_metadata("design:returntype", Promise)
], DatasController.prototype, "relationDataAdd", null);
DatasController = _ts_decorate([
    (0, _common.Controller)(),
    (0, _common.UseGuards)(_dataapilimiterguard.DataApiLimiterGuard, _globalguard.GlobalGuard),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _datasservice.DatasService === "undefined" ? Object : _datasservice.DatasService
    ])
], DatasController);
